import styled from '@emotion/styled';

export const SDangerActionItem = styled.div`
  color: #ff4d4f;
`;

export const SStatusCell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SFiltersContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  height: 88px;
  
  & .iban-input {
    min-width: 320px;
  }
  & .ant-form-inline .ant-space {
    align-items: flex-start;
  }
`;
